import { Button, Callout, Flex, Heading, Text } from '@radix-ui/themes'
import { JSX } from 'react'
import { SideDrawer } from '@Components/common/side-drawer'

type EditDrawerFrameProps = {
  title: string
  saveError: string | null
  isSaving: boolean
  canSave: boolean
  onSave: () => void
  onClose: () => void
  children: JSX.Element | JSX.Element[]
}

// Common chrome for both edit sidebars: title, save error, and Save/Cancel
export const EditDrawerFrame = ({
  title,
  saveError,
  isSaving,
  canSave,
  onSave,
  onClose,
  children,
}: EditDrawerFrameProps) => (
  <SideDrawer onClose={onClose}>
    <Flex direction="column" gap="4">
      <Heading as="h3" size="4">
        {title}
      </Heading>
      <Text size="2" color="gray">
        Changes reach players as soon as you save.
      </Text>

      {saveError ? (
        <Callout.Root color="red" role="alert">
          <Callout.Text>{saveError}</Callout.Text>
        </Callout.Root>
      ) : null}

      {children}

      <Flex gap="2" mt="4">
        <Button onClick={onSave} disabled={!canSave || isSaving}>
          {isSaving ? 'Saving...' : 'Save'}
        </Button>
        <Button variant="outline" onClick={onClose}>
          Cancel
        </Button>
      </Flex>
    </Flex>
  </SideDrawer>
)
